<template>
  <slot></slot>
  <Toast />
  <ConfirmDialog />
</template>

<script setup lang="ts">
import Toast from "@/components/Toast/Index.vue";
import ConfirmDialog from "@/components/ui/ConfirmDialog.vue";
</script>
